<template>
  <div class="step-loading">
    <div class="loader-stack">
      <div class="loader-animation">
        <lottie-player
          src="/animations/RiseupLoader.json"
          autoplay
          loop
          background="transparent"
          speed="1"
        />
      </div>

      <h1 class="loading-heading" dir="auto">אנחנו מחברים את החשבון שלך</h1>
      <p class="loading-subtitle" dir="auto">זה יקח לנו עוד רגע...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepBankLoading',
};
</script>

<style lang="scss" scoped>
.step-loading {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  padding: 0 27px;
}

.loader-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  // Nudge the whole stack up a little so the visual optical center matches
  // the Figma layout (image top at y=250 out of ~847 = ~30% from top).
  margin-top: -40px;
}

.loader-animation {
  width: 386px;
  height: 244px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;

  lottie-player {
    width: 100%;
    height: 100%;
    display: block;
  }

  @media (max-width: 500px) {
    width: 322px;
    height: 204px;
    margin-bottom: 20px;
  }
}

.loading-heading {
  font-family: 'SimplerProAlte', sans-serif;
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  font-style: normal;
  font-synthesis: none;
  color: #205441;
  text-align: center;
  margin: 0 0 10px;
  max-width: 314px;

  @media (max-width: 500px) {
    font-size: 22px;
    line-height: 30px;
  }
}

.loading-subtitle {
  font-family: 'SimplerPro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #205441;
  text-align: center;
  margin: 0;
  max-width: 256px;
}
</style>
